<script setup>
import {computed, ref, watch} from "vue";
import { useStore } from "vuex";

const CARD_INPUT_STYLE = {
  base: {
    color: '#000000',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#343a40',
    }
  },
  invalid: {
    color: '#eb1c26',
    iconColor: '#eb1c26',
  }
}

defineProps({
  showNotice: {
    type: Boolean,
    required: false,
    default: true,
  },
  textCenter: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const store = useStore();

const cardElement = ref(null);
const cardError = computed(() => store.getters['billing/cardError']);

watch(
  cardElement,
  (newElement) => {
    if (!newElement) {
      return;
    }

    store.dispatch('billing/createCardElement', {
      element: cardElement.value,
      options: {
        style: CARD_INPUT_STYLE,
      }
    });
  },
  { immediate: true }
)

</script>

<template>
  <div>
    <div
      class="card-container"
    >
      <div ref="cardElement" />
    </div>

    <div
      v-if="cardError"
      class="xs-mt-5 font-size-16 card-error"
      :class="{
        'text-center': textCenter,
      }"
      role="alert"
      v-html="cardError"
    />

    <p v-if="showNotice">
      <em><strong>Please note,</strong> this payment method will also be used for future payments.</em>
    </p>
  </div>
</template>

<style scoped>


  .card-error {
    color:#eb1c26;
  }
</style>
